'use client';

export default function HeadSchema() {
	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
				__html: JSON.stringify({
					'@context': 'https://schema.org',
					'@type': 'Organization',
					name: 'Otherworld',
					url: 'https://www.otherworld.xyz',
					logo: 'https://cdn.otherworld.xyz/public/assets/logo/Logo_Dark.png',
					sameAs: [
						'https://twitter.com/otherworld_xyz',
						'https://discord.gg/otherworld',
						'https://youtube.com/@otherworldxyz',
					],
				}),
			}}
		/>
	);
}
